import React from "react";
import "./AboutUs.css";
import options from "./stablty-options.png";

const AboutUs = () => {
  return (
    <>
      <div id="about-us-container">
        <div id="about-us-img-container">
          <img src={options} />
        </div>
        <div id="about-us-text">
          <h1>What Makes Us Unique</h1>
          <p>
            Stablty helps you control your life by providing key skills to help
            you navigate heightened emotional states like stress, anger, and
            disappointment. Clients work towards a foundation of strong optimism
            to develop resilience against hardships.
          </p>

          <button id="about-us-btn">Learn More</button>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
